import React from "react";
import CalendarWeekTicket from "./CalendarWeekTicket";

const CalendarWeekDay = ({ year, month, day, tickets = [], onDayClick }) => {
  const handleClick = () => {
    onDayClick && onDayClick({ day, month, year, tickets });
  };

  const isToday = () => {
    const today = new Date();
    return (
      day === today.getDate() &&
      month === today.getMonth() &&
      year === today.getFullYear()
    );
  };

  return (
    <div
      onClick={handleClick}
      className="flex flex-col space-y-6 p-3 border-r border-[#BFC2CE] bg-white cursor-pointer"
    >
      <span
        className={`font-OpenSansRegular text-[16px] not-italic font-normal leading-normal tracking-[-0.24px] ${
          isToday() ? "text-[#0065FD] font-extrabold" : "text-[#80869E]"
        }`}
      >
        {day}
      </span>
      <div className="flex flex-col space-y-4">
        {tickets.length > 0 &&
          tickets.map((ticket, index) => (
            <CalendarWeekTicket key={index} ticket={ticket} />
          ))}
      </div>
    </div>
  );
};

export default CalendarWeekDay;
